"use strict";

(function () {
  'use strict';

  angular.module('lr.DataStream').filter('eventsFilter', function () {
    return function (inputs, filterValues) {
      var output = [];
      angular.forEach(inputs, function (input) {
        //filter out values if they are in the filterValues array
        if (filterValues.indexOf(input.liveRezEventTypeID) === -1) {
          output.push(input);
        }
      });
      return output;
    };
  });
})();